import { FaArrowRight } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { toRoutePath } from "../../lib/seo";
import classes from "./FeatureImageContent.module.css";

import defaultImage from "./featureimagecontent_img.webp";

export default function FeatureImageContent({
  image = defaultImage,
  imageAlt = "",
  heading = "",
  description = "",
  buttonLabel = "",
  buttonUrl = "",
}) {
  return (
    <section className={classes.section}>
      <div className={classes.shell}>
        <div className={classes.panel}>
          <img
            src={image}
            alt={imageAlt}
            className={classes.media}
            loading="lazy"
          />

          <svg
            className={classes.navyShape}
            viewBox="0 0 1000 600"
            preserveAspectRatio="none"
            aria-hidden="true"
          >
            <path
              className={classes.navyFill}
              d="M0,0 L680,0 L400,600 L0,600 Z"
            />

            <path className={classes.navyEdge} d="M680,0 L400,600" />
          </svg>

          <span className={classes.arcLine1} aria-hidden="true" />
          <span className={classes.arcLine2} aria-hidden="true" />

          <div className={classes.content}>
            {heading && (
              <h2 className={classes.heading}>
                {heading}
              </h2>
            )}

            {description && (
              <p className={classes.paragraph}>
                {description}
              </p>
            )}

            {buttonLabel && buttonUrl && (
              <Link to={toRoutePath(buttonUrl)} className={`btn ${classes.button}`}>
                {buttonLabel}
                <FaArrowRight aria-hidden="true" />
              </Link>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
